import '@fontsource/roboto';
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import './plugins/moment';
import './plugins/vuetify-confirm';
import axios from 'axios';
import './components/global-components';
import './filters/global-filters';

Vue.config.productionTip = (process.env.VUE_APP_PRODUCTION_TIP === 'true');
Vue.config.devtools = (process.env.VUE_APP_DEV_TOOLS === 'true');

const setLocale = () => {
    axios.defaults.headers.common['Accept-Language'] = i18n.locale;
    const html = document.querySelector('html');
    if (html) {
        html.setAttribute('lang', i18n.locale);
    }
}

const setBaseUrl = () => {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
}

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App),
    created() {
        setLocale();
        setBaseUrl();
        axios.interceptors.request.use(
            (config) => {
                store.commit('startWorking');
                return config;
            },
            (error) => {
                store.commit('stopWorking');
                return Promise.reject(error);
            });
        axios.interceptors.response.use(
            (response) => {
                store.commit('stopWorking');
                return response;
            },
            (error) => {
                store.commit('stopWorking');
                if (error.response && error.response.status === 401) {
                    const wwwAuthenticate = Object.keys(error.response.headers).find(key => key.toLowerCase() === 'www-authenticate');
                    if (wwwAuthenticate && error.response.headers[wwwAuthenticate].toLowerCase().includes('invalid_token')) {
                        store.commit('setLoggedUser', null);
                        router.push('/login');
                        return Promise.reject(error);
                    }
                }
                store.commit('setApplicationMessage', error.response && !(typeof error.response.data === 'string') ? error.response.data : { title: error.message });
                return Promise.reject(error);
            });
    }
}).$mount('#app');